import AppConstant from '../../../../config/app.constants';
import _ from 'lodash';

class SoftDeletedShipmentsController {
    /*@ngInject*/
    constructor(Auth, User, $q, $state, ShipmentService, DataCounter, Modal, $translate, Navigation, $rootScope) {
        this.Auth = Auth;
        this.User = User;
        this.$q = $q;
        this.$state = $state;
        this.ShipmentService = ShipmentService;
        this.DataCounter = DataCounter;
        this.Modal = Modal;
        this.$translate = $translate;
        this.Navigation = Navigation;
        this.$rootScope = $rootScope;

        this.model = {
            branch: User.getUser().branchId,
            softDeletedShipments: [],
            toLocation: '',
            selectedUser: '',
            selectedReason: null,
            trackingId: '',
            date: ''
        }

        this.pagination = {
            page: 1,
            total: 0,
            pageLimit: 10,
            maxPages: 10
        }

        this.sortOrder = {
            fieldName: 'vaultDate',
            order: 'DESC'
        }

        this.totalLocations = 0;
        this.totalUsers = 0;
        this.totalReasons = 0;
        this.locationList = [];
        this.userList = [];
        this.reasonList = [];
        this.shipmentData = '';
        this.$rootScope.$broadcast('routeChange', '/app/branch-management/deleted-shipments');
    }

    $onInit() {
        this.moment = moment;
        this.shipmentData = this.DataCounter.getData();
        this.getUniqueRecords();
        if (this.shipmentData && this.shipmentData.isRedirected) this.filterRecords();
        else this.getSoftDeletedShipments();
    }

    getSoftDeletedShipments() {
        const searchObj = {
            queryJSON: {
                rules: [
                    {
                        field: 'branchId',
                        condition: '=',
                        data: this.model.branch
                    },
                    {
                        field: 'deleted',
                        condition: '=',
                        data: true
                    }
                ],
                operator: 'AND'
            },
            order: {
                fieldName: this.sortOrder.fieldName,
                keyword: this.sortOrder.order
            }
        };

        if (this.model.trackingId) {
            searchObj.queryJSON.rules.push({
                field: 'trackingId',
                condition: 'like',
                data: "%" + this.model.trackingId + "%"
            });
        }

        if (this.model.date) {
            searchObj.queryJSON.rules.push({
                field: 'vaultDate',
                condition: '=',
                data: moment(this.model.date).format('YYYY-MM-DD')
            });
        }

        if (this.model.toLocation) {
            searchObj.queryJSON.rules.push({
                field: 'toLocationId',
                condition: '=',
                data: this.model.toLocation.Value
            });
        }

        if (this.model.selectedUser) {
            searchObj.queryJSON.rules.push({
                field: 'deletedByUserId',
                condition: '=',
                data: this.model.selectedUser.Value
            });
        }

        if (this.model.selectedReason) {
            searchObj.queryJSON.rules.push({
                field: 'deletedReason',
                condition: '=',
                data: this.model.selectedReason.reason
            });
        }

        this.model.loading = true;
        return this.ShipmentService.all(searchObj, (this.pagination.page - 1) * this.pagination.pageLimit, this.pagination.pageLimit)
            .then((data) => {
                this.model.softDeletedShipments = data.results;
                this.pagination.total = data.total;
            })
            .catch((err) => {
                console.log(err);
            })
            .finally(() => {
                this.model.loading = false;
            })
    }

    pageChange() {
        this.getSoftDeletedShipments();
    }

    getUniqueRecords() {
        this.isLoading = true;
        this.ShipmentService.getUniqueRecords(this.model.branch)
            .then((data) => {
                this.model.uniqueRecords = data.results;
            })
            .then(() => {
                this.loadLocations();
                this.loadUsers();
                // this.loadReason();
            })
            .catch((err) => {
                console.log(err);
            })
            .finally(() => {
                this.isLoading = false;
            })
    }

    loadLocations() {
        this.totalLocations = this.model.uniqueRecords.locations.length;
        const location = this.mappingLocation(this.model.uniqueRecords.locations);
        this.locationList = this.locationList.concat(location);
    }

    mappingLocation(data) {
        return data.map((loc) => {
            return {
                Key: loc.locationId + ' | ' + loc.locationName,
                Value: loc.locationId
            }
        });
    }

    loadUsers() {
        this.totalUsers = this.model.uniqueRecords.userIds.length;
        const user = this.mappingUser(this.model.uniqueRecords.userIds);
        this.userList = this.userList.concat(user);
    }

    mappingUser(data) {
        return data.map((user) => {
            return {
                Key: user.id + ' | ' + user.name,
                Value: user.id
            }
        });
    }

    loadReason() {
        this.totalReasons = this.model.uniqueRecords.deletedReasons.length;
        const reason = this.mappingReason(this.model.uniqueRecords.deletedReasons);
        this.reasonList = this.reasonList.concat(reason);
    }

    mappingReason(data) {
        return data.map((d) => {
            return {
                Key: d.reason,
                Value: d.reason
            }
        });
    }

    goToServiceHistory(data) {
        const obj = {
            locationId: data.toLocation.id,
            vaultDate: null,
            isRedirected: true
        }
        this.DataCounter.setData(obj);
        this.$state.go('branchManagement.locations');
    }

    goToRouteTab(data) {
        const obj = {
            routeId: data.routeId,
            vaultDate: data.vaultDate,
            isRedirected: true
        }
        this.DataCounter.setData(obj);
        this.$state.go('branchManagement.routes');
    }

    resetData() {
        this.model.trackingId = null;
        this.model.date = null;
        this.model.toLocation = null;
        this.model.selectedUser = null;
        this.model.selectedReason = null;
        this.getSoftDeletedShipments();
    }

    filterRecords() {
        if (this.shipmentData && this.shipmentData.isRedirected) {
            this.model.trackingId = this.shipmentData.trackingId;
            this.getSoftDeletedShipments()
                .then(() => {
                    this.resetFilters();
                })
        }
    }

    resetFilters() {
        if (this.shipmentData) {
            this.shipmentData.isRedirected = false;
            this.shipmentData = this.DataCounter.setData();
        }
    }

    confirmUndoDelete(shipment) {
        if (this.loading) return;
        this.loading = true;

        this.Modal.confirm({
            header: this.$translate.instant('softDeletedShipments.undo_delete_title'),
            message: this.$translate.instant('softDeletedShipments.undo_delete_warning') + ` <strong>${shipment.trackingId}</strong>?`,
            callback: (({
                modal,
                $scope
            }) => {
                modal.close();
                this.undoSoftDeleteShipment(shipment);
            }),
            negative: (({
                modal
            }) => {
                modal.close();
                this.loading = false;
            }),
            type: 'danger'
        })
    }

    undoSoftDeleteShipment(shipment) {
        this.ShipmentService.undoSoftDeleteShipment(shipment.id, shipment.branchId, shipment.trackingId)
            .then(() => {
                this.resetFilters();
                this.getSoftDeletedShipments();
            })
            .catch((err) => {
                console.log(err);
                if (err && err.data && err.data.message) {
                    if (err.data.message === '92719') {
                        let errorMessage = this.$translate.instant('error.' + err.data.message, {
                            trackingId: shipment.trackingId
                        })
                        this.Modal.errorModal(errorMessage);
                    }
                    else {
                        this.Modal.errorModal(err.data.message);
                    }
                }
            })
            .finally(() => {
                this.loading = false;
            })
    }

    goToItemHistory(data) {
        this.Navigation.goToItemHistory(data.trackingId, null);
    }

}

export default SoftDeletedShipmentsController;



// WEBPACK FOOTER //
// ./client/app/components/branch_management/components/deleted_shipments/deleted_shipments.controller.js